import React, { useRef } from 'react';

import DxLink from '../dxlink/DxLink';

export default function ForumRedirecter() {
	const redirectIssued = useRef(false);

	const doRedirect = () => {
		let targetUrl = 'https://community.genesys.com/communities/gc-developer-community?CommunityKey=a39cc4d6-857e-43cb-be7b-019581ab9f38';

		// Debounce redirection; don't redirect on every render
		if (redirectIssued.current !== true) {
			window.location.href = targetUrl;
			redirectIssued.current = true;
		}

		// Render a link just in case the redirect doesn't work
		return (
			<div>
				Redirecting to the <DxLink href={targetUrl}>Developer Community</DxLink>...
			</div>
		);
	};

	return doRedirect();
}
